import axiosInstance from '../../../core/api/interceptors/axiosInterceptor';

/**
 * Get all tickets de caisse
 * @returns {Promise} All tickets
 */
export const getAllTickets = async () => {
  try {
    const response = await axiosInstance.get('/Ticket');
    return response.data;
  } catch (error) {
    console.error('Error fetching tickets:', error);
    throw error;
  }
};

/**
 * Get ticket by ID
 * @param {number} id - Ticket ID
 * @returns {Promise} Ticket details
 */
export const getTicketById = async (id) => {
  try {
    const response = await axiosInstance.get(`/Ticket/${id}`);
    return response.data;
  } catch (error) {
    console.error('Error fetching ticket:', error);
    throw error;
  }
};

/**
 * Get tickets by customer ID
 * @param {number} customerId - Customer ID
 * @returns {Promise} Customer tickets
 */
export const getTicketsByCustomerId = async (customerId) => {
  try {
    const response = await axiosInstance.get(`/Ticket/by-customer/${customerId}`);
    return response.data;
  } catch (error) {
    console.error('Error fetching customer tickets:', error);
    throw error;
  }
};

/**
 * Create new ticket
 * @param {Object} ticketData - Ticket data
 * @returns {Promise} Created ticket
 */
export const createTicket = async (ticketData) => {
  try {
    const response = await axiosInstance.post('/Ticket', ticketData);
    return response.data;
  } catch (error) {
    console.error('Error creating ticket:', error);
    throw error;
  }
};

/**
 * Update ticket
 * @param {number} id - Ticket ID
 * @param {Object} ticketData - Updated ticket data
 * @returns {Promise} Updated ticket
 */
export const updateTicket = async (id, ticketData) => {
  try {
    const response = await axiosInstance.put(`/Ticket/${id}`, ticketData);
    return response.data;
  } catch (error) {
    console.error('Error updating ticket:', error);
    throw error;
  }
};

/**
 * Delete ticket
 * @param {number} id - Ticket ID
 * @returns {Promise}
 */
export const deleteTicket = async (id) => {
  try {
    const response = await axiosInstance.delete(`/Ticket/${id}`);
    return response.data;
  } catch (error) {
    console.error('Error deleting ticket:', error);
    throw error;
  }
};

export default {
  getAllTickets,
  getTicketById,
  getTicketsByCustomerId,
  createTicket,
  updateTicket,
  deleteTicket,
};